import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {vProjetProg} from 'src/app/domain';
import {ProjetprogService} from 'src/app/modules/services/projetprog.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {translator} from 'src/assets/translator/translator';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-projet-prog-details',
    templateUrl: './projet-prog-details.component.html',
    styleUrls: ['./projet-prog-details.component.css']
})
export class ProjetProgDetailsComponent implements OnInit {
    public current_lang = this.apptranstlte.getDefaultLang();

    form: FormGroup;
    isLoading = false;

    typecommande: String;
    typecommandeAr: String;
    valfour: String;
    valmarchcadre: String;
    valmarchcadreAr: String;
    valdemfinanc: string;
    valpossigroup: string;
    valmarchgen: string;
    id: any;
    projet: vProjetProg;
    translator = translator;
    fields = {
        bidNo: this.createField('', 'N° d' + '\'' + 'avis d' + '\'' + 'AO'),
        bidNoModif: this.createField('', 'N° d' + '\'' + 'avis d' + '\'' + 'AO modifié'),
        publicDt: this.createField('', 'Date et heure de publication'),
        planNmFr: this.createField('bidNmFr', 'Objet de lAO'),

        dateprev: this.createField('', 'Date prévue du début de l' + '\'' + 'exécution'),
        lieuouv: this.createField('', 'Lieu d' + '\'' + 'exécution'),
        acheteur: this.createField('', 'Nom de l' + '\'' + 'acheteur publique'),
        srfinanc: this.createField('', 'Source de financement'),
        tcommande: this.createField('', 'Type de commande'),
        annee: this.createField('', 'Année'),


        dateprevelab: this.createField('', 'Date prévue de l' + '\'' + 'élaboration des cahiers des charges'),
        dateprevpub: this.createField('', 'Date prévue de la publication de l' + '\'' + 'avis d' + '\'' + 'appel d' + '\'' + 'offres'),
        dateprevupres: this.createField('', 'Date prévue de la présentation de dossier à la commission des marchés ou d' + '\'' + 'achats'),
        encouragement: this.createField('', 'Encouragement des PME'),
        procedureTypeStrFr: this.createField('', 'procedureTypeStrFrE'),


    };
    dataSource: MatTableDataSource<any>;

    labels = [
        'N° d' + '\'' + 'avis d' + '\'' + 'AO',
        'N° d' + '\'' + 'avis d' + '\'' + 'AO modifié',
        'Date et heure de publication',
        'Objet d' + '\'' + 'A.O',
        'Date prévue du début de l' + '\'' + 'exécution',
        'Lieu de l' + '\'' + 'exécution',
        'Nom de l' + '\'' + 'acheteur publique',
        'Source de financement',
        'Type de commande',
        'Année',
        'Date prévue de l' + '\'' + 'élaboration des cahiers des charges',
        'Date prévue de la publication de l' + '\'' + 'avis d' + '\'' + 'appel d' + '\'' + 'offres',
        'Date prévue de la présentation de dossier à la commission des marchés ou d' + '\'' + 'achats',
        'Encouragement des PME',
        'mode de passation'
    ];


    data = [];

    displayedColumns = [];


    dataColumns = [
        'planNo',
        '',
        'publicDt',
        'planNmFr',
        'bidExecutionExpDt',
        'executionPlaceStrFr',
        'instNm',
        'financialMethodStrFr',
        'typecommande',
        'planYear',
        'biddingDocExpDt',
        'bidPublicExpDt',
        'procCommissionExpDt',
        '',
        'procedureTypeStrFr'
    ];
    dataColumnsAr = [
        'planNo',
        '',
        'publicDt',
        'planNmAr',
        'bidExecutionExpDt',
        'executionPlaceStrAr',
        'instNm',
        'financialMethodStrAr',
        '',
        'planYear',
        'biddingDocExpDt',
        'bidPublicExpDt',
        'procCommissionExpDt',
        '',
        'procedureTypeStrAr'
    ];
    epPlanMasterId = null;

    constructor(
        private formBuilder: FormBuilder,
        private projetservice: ProjetprogService,
        private toastService: ToastService,
        private router: Router,
        private apptranstlte: AppTranslateService,
        private activatedRoute: ActivatedRoute,
        private translateS: TranslateService
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;

        });


    }

    getlang() {
        return this.apptranstlte.getDefaultLang();
    }

    ngOnInit(): void {
        // this.getClassification();
        // this.get();
        this.activatedRoute.params.subscribe((params) => {
            const {epPlanMasterId} = params.epPlanMasterId;

            this.epPlanMasterId = params.epPlanMasterId;

            // console.log("ssss",this.movement)
        });
        this.get();

    }


    get() {
        if (this.getlang() === 'ar') {
            this.dataColumns = this.dataColumnsAr;
        }
        this.projetservice
            .findByIdproj(this.epPlanMasterId)
            .subscribe({
                next: (getproj) => {
                    this.projet = getproj['payload'];
                    this.valfour = this.projet.bizKindNmFr + ' , ' + this.projet.bizKindNmFr;
                    if (this.projet.smallBizYn == 'Y') {
                        this.valmarchcadre = 'oui';
                        this.valmarchcadreAr = 'نعم';
                    } else {
                        this.valmarchcadre = 'non';
                        this.valmarchcadreAr = 'لا';
                    }
                    this.typecommande = this.projet.pbkStrFr + ' , ' + this.projet.bizKindNmFr;
                    this.typecommandeAr = this.projet.pbkStrAr + ' , ' + this.projet.bizKindNmAr;
                    this.data.push(this.projet);
                    let transposedData = [];
                    for (let column = 0; column < this.dataColumns.length; column++) {
                        transposedData[column] = {
                            label: this.labels[column]
                        };
                        for (let row = 0; row < this.data.length; row++) {
                            transposedData[column][`column${row}`] = this.data[row][this.dataColumns[column]];
                        }
                    }
                    this.dataSource = new MatTableDataSource(transposedData);
                    this.displayedColumns = ['label'];
                    for (let i = 0; i < this.data.length; i++) {
                        this.displayedColumns.push('column' + i);
                    }

                },
                error: () => {
                    this.isLoading = false;
                    this.toastService.error('server_error');
                },
                complete: () => {
                    this.isLoading = false;
                },
            });

    }


    private createField(name: string, label: string) {
        return {name, label};
    }


}

